import { getDefinedRegion } from './getRegion';

export const getLocalizedImg = (imgNL: string, imgCOM: string) => {
  const domen = getDefinedRegion();

  switch (domen) {
    case 'nl':
      return imgNL;

    default:
      return imgCOM;
  }
};
